/**
 * Servicio para validar acceso de administrador
 * Verifica que:
 * 1. El usuario exista en Firebase
 * 2. Su email coincida con VUE_APP_ADMIN_EMAIL del .env
 */

export function validateAdminEmail(userEmail, envAdminEmail) {
  if (!userEmail || !envAdminEmail) {
    return {
      valid: false,
      error: 'Configuración incompleta'
    }
  }

  if (userEmail !== envAdminEmail) {
    return {
      valid: false,
      error: `Solo ${envAdminEmail} puede acceder al admin`
    }
  }

  return {
    valid: true,
    error: null
  }
}

export function getAdminEmailFromEnv() {
  const adminEmail = process.env.VUE_APP_ADMIN_EMAIL
  if (!adminEmail) {
    console.warn('VUE_APP_ADMIN_EMAIL no está configurado en .env')
    return null
  }
  return adminEmail
}
